/* Scroll-snap carousel nav. The track scrolls natively (swipe/keyboard);
   these buttons page it one viewport at a time for pointer users. */

class ScrollCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    const controls = document.querySelector(`[data-carousel-controls="${this.id}"]`) || this;
    const prev = controls.querySelector('[data-carousel-prev]');
    const next = controls.querySelector('[data-carousel-next]');
    if (!this.track) return;

    const page = (direction) => {
      const item = this.track.querySelector('.carousel__item');
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const distance = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.85;
      this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', () => page(-1));
    if (next) next.addEventListener('click', () => page(1));

    const sync = () => {
      const max = this.track.scrollWidth - this.track.clientWidth - 4;
      if (prev) prev.toggleAttribute('disabled', this.track.scrollLeft <= 4);
      if (next) next.toggleAttribute('disabled', this.track.scrollLeft >= max);
    };
    this.track.addEventListener('scroll', sync, { passive: true });
    this.track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        page(1);
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        page(-1);
      }
    });
    window.addEventListener('resize', sync);
    sync();
  }
}

if (!customElements.get('scroll-carousel')) customElements.define('scroll-carousel', ScrollCarousel);
